/** BIBLIOTECA DE SÍMBOLOS SOLUARQ (Fase 5 — Etapa 3)
 *  Símbolos técnicos paramétricos en SVG (sin imágenes estáticas). No es un catálogo:
 *  el producto/SKU/costo siguen viviendo SOLO en el Catálogo Soluarq. */

// resolver: nombre de producto → id de símbolo (con ángulo desde el nombre o el contexto de unión)
export const resolverSimbolo = (nombre = '', ctx = {}) => {
  const n = String(nombre).toLowerCase();
  const ang = (n.match(/(135|180|90)/) || [])[1] || String(ctx.angulo || '90').replace('°', '');
  if (n.includes('bisagra') && n.includes('muro')) return 'bisagra_muro_vidrio';
  if (n.includes('bisagra')) return `bisagra_vidrio_vidrio_${ang}`;
  if (n.includes('clip')) {
    if (n.includes('lateral')) return 'clip_lateral';
    if (n.includes('inferior')) return 'clip_inferior';
    if (n.includes('superior')) return 'clip_superior';
    return 'clip_estandar';
  }
  if (n.includes('barra') && n.includes('estab')) return 'barra_estabilizadora';
  if (/jalador|toallero|pomo/.test(n)) {
    if (n.includes('pomo')) return 'jalador_pomo';
    if (n.includes('tipo c') || / c \d| c$/.test(n)) return 'jalador_c';
    if (n.includes('jalador') && n.includes('toallero')) return 'jalador_toallero';
    if (n.includes('toallero')) return 'toallero';
    return 'jalador';
  }
  if (n.includes('herraje') && n.includes('vidrio')) return `herraje_vidrio_vidrio_${ang}`;
  if (n.includes('soporte') || n.includes('herraje')) return 'otro_herraje';
  return 'otro_herraje';
};

// renders paramétricos (unidades en mm del lienzo; col = color activo)
const bisagraVV = (col, ang) => (
  <>
    <rect x={-50} y={-55} width={42} height={110} rx={8} fill={col} />
    <g transform={`rotate(${180 - Number(ang)})`}>
      <rect x={8} y={-55} width={42} height={110} rx={8} fill="none" stroke={col} strokeWidth={9} />
    </g>
    <circle cx={0} cy={0} r={13} fill="#0F172A" />
  </>
);
const herrajeVV = (col, ang) => (
  <>
    <rect x={-52} y={-40} width={44} height={80} rx={5} fill={col} />
    <g transform={`rotate(${180 - Number(ang)})`}>
      <rect x={8} y={-40} width={44} height={80} rx={5} fill={col} opacity={0.55} />
    </g>
    <line x1={-8} y1={-46} x2={-8} y2={46} stroke="#0F172A" strokeWidth={7} />
  </>
);
const clip = (col, lado) => (
  <>
    <rect x={-42} y={-42} width={84} height={84} rx={8} fill="none" stroke={col} strokeWidth={10} />
    {lado === 'lateral' && <line x1={-42} y1={0} x2={42} y2={0} stroke={col} strokeWidth={9} />}
    {lado === 'inferior' && <line x1={0} y1={0} x2={0} y2={42} stroke={col} strokeWidth={9} />}
    {lado === 'superior' && <line x1={0} y1={-42} x2={0} y2={0} stroke={col} strokeWidth={9} />}
    {lado === 'estandar' && <circle cx={0} cy={0} r={12} fill={col} />}
  </>
);

export const SIMBOLOS = {
  puerta_abatible: { nombre: 'Puerta abatible PABM', categoria: 'puertas', familia_tecnica: 'pabm' },
  vidrio_fijo: { nombre: 'Vidrio fijo VTF', categoria: 'fijos', familia_tecnica: 'vtf' },
  bisagra_muro_vidrio: {
    nombre: 'Bisagra muro-vidrio', categoria: 'bisagras', familia_tecnica: 'pabm',
    render: (col) => (<>
      <rect x={-58} y={-52} width={22} height={104} fill="#0F172A" />
      <rect x={-30} y={-52} width={42} height={104} rx={8} fill={col} />
      <rect x={18} y={-52} width={42} height={104} rx={8} fill="none" stroke={col} strokeWidth={9} />
      <circle cx={-6} cy={0} r={12} fill="#0F172A" />
    </>),
  },
  bisagra_vidrio_vidrio_90: { nombre: 'Bisagra vidrio-vidrio 90°', categoria: 'bisagras', familia_tecnica: 'pabm', render: (col) => bisagraVV(col, 90) },
  bisagra_vidrio_vidrio_135: { nombre: 'Bisagra vidrio-vidrio 135°', categoria: 'bisagras', familia_tecnica: 'pabm', render: (col) => bisagraVV(col, 135) },
  bisagra_vidrio_vidrio_180: { nombre: 'Bisagra vidrio-vidrio 180°', categoria: 'bisagras', familia_tecnica: 'pabm', render: (col) => bisagraVV(col, 180) },
  herraje_vidrio_vidrio_90: { nombre: 'Herraje vidrio-vidrio 90°', categoria: 'herrajes', familia_tecnica: 'vtf', render: (col) => herrajeVV(col, 90) },
  herraje_vidrio_vidrio_135: { nombre: 'Herraje vidrio-vidrio 135°', categoria: 'herrajes', familia_tecnica: 'vtf', render: (col) => herrajeVV(col, 135) },
  herraje_vidrio_vidrio_180: { nombre: 'Herraje vidrio-vidrio 180°', categoria: 'herrajes', familia_tecnica: 'vtf', render: (col) => herrajeVV(col, 180) },
  clip_lateral: { nombre: 'Clip lateral', categoria: 'clips', familia_tecnica: 'vtf', render: (col) => clip(col, 'lateral') },
  clip_inferior: { nombre: 'Clip inferior', categoria: 'clips', familia_tecnica: 'vtf', render: (col) => clip(col, 'inferior') },
  clip_superior: { nombre: 'Clip superior', categoria: 'clips', familia_tecnica: 'vtf', render: (col) => clip(col, 'superior') },
  clip_estandar: { nombre: 'Clip estándar', categoria: 'clips', familia_tecnica: 'vtf', render: (col) => clip(col, 'estandar') },
  jalador: {
    nombre: 'Jalador', categoria: 'jaladores', familia_tecnica: 'pabm',
    render: (col) => (<><rect x={-9} y={-100} width={18} height={200} rx={9} fill={col} /><circle cx={0} cy={-100} r={14} fill={col} /><circle cx={0} cy={100} r={14} fill={col} /></>),
  },
  jalador_toallero: {
    nombre: 'Jalador toallero', categoria: 'jaladores', familia_tecnica: 'pabm',
    render: (col) => (<><rect x={-9} y={-130} width={18} height={260} rx={9} fill={col} /><rect x={-34} y={-130} width={26} height={14} fill={col} /><rect x={-34} y={116} width={26} height={14} fill={col} /></>),
  },
  toallero: {
    nombre: 'Toallero', categoria: 'jaladores', familia_tecnica: 'pabm',
    render: (col) => (<><rect x={-130} y={-9} width={260} height={18} rx={9} fill={col} /><rect x={-130} y={8} width={14} height={26} fill={col} /><rect x={116} y={8} width={14} height={26} fill={col} /></>),
  },
  jalador_c: {
    nombre: 'Jalador tipo C', categoria: 'jaladores', familia_tecnica: 'pabm',
    render: (col) => <path d="M 40 -80 A 80 80 0 1 0 40 80" fill="none" stroke={col} strokeWidth={20} strokeLinecap="round" />,
  },
  jalador_pomo: {
    nombre: 'Jalador tipo pomo', categoria: 'jaladores', familia_tecnica: 'pabm',
    render: (col) => (<><circle cx={0} cy={0} r={42} fill={col} /><circle cx={0} cy={0} r={16} fill="#0F172A" /></>),
  },
  barra_estabilizadora: {
    nombre: 'Barra estabilizadora', categoria: 'barras', familia_tecnica: 'vtf',
    render: (col) => (<><rect x={-140} y={-9} width={280} height={18} rx={9} fill={col} /><circle cx={-140} cy={0} r={16} fill={col} /><circle cx={140} cy={0} r={16} fill={col} /></>),
  },
  otro_herraje: {
    nombre: 'Otro herraje', categoria: 'generico', familia_tecnica: '',
    render: (col) => (<>
      <rect x={-46} y={-46} width={92} height={92} rx={10} fill="none" stroke={col} strokeWidth={10} />
      <line x1={-46} y1={0} x2={46} y2={0} stroke={col} strokeWidth={8} />
      <line x1={0} y1={-46} x2={0} y2={46} stroke={col} strokeWidth={8} />
    </>),
  },
};

export const renderSimbolo = (sid, col) => {
  const s = SIMBOLOS[sid] || SIMBOLOS.otro_herraje;
  return s.render ? s.render(col) : SIMBOLOS.otro_herraje.render(col);
};

// Arquitectura preparada para familias futuras — SOLO ids reservados (sin recetas ni renders todavía)
export const FAMILIAS_FUTURAS = {
  barandas: ['poste', 'vidrio_baranda', 'clip_baranda', 'pasamanos', 'varilla', 'soporte_baranda', 'anclaje'],
  fachadas: ['perfil_fachada', 'vidrio_fachada', 'puerta_fachada', 'fijo_fachada', 'union_fachada'],
  aranas: ['arana', 'punto_fijacion', 'soporte_arana', 'vidrio_arana'],
  corredizos: ['riel', 'carro', 'guia', 'hoja_corrediza', 'jalador_corredizo', 'fijo_corredizo'],
  bacalar: ['riel_bacalar', 'hojas_bacalar', 'fijos_bacalar', 'herrajes_bacalar', 'direccion_desplazamiento'],
};
